import {
  verifyFbTokenLoading,
  verifyFbTokenSuccess,
  verifyFbTokenFailure,
} from "@redux/slices/fbAuthSlice.js"
import { VerifyFbAuthToken } from "@services/verifyFbAuthToken.js"
import { notify } from "@utils/notify"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import useAuth from "./useAuth"

const useFbAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { handleGetToken } = useAuth()

  const handleVerifyFbToken = async (token) => {
    try {
      dispatch(verifyFbTokenLoading())
      const response = await VerifyFbAuthToken(token)
      dispatch(verifyFbTokenSuccess(response.data))
      const { userId } = response.data.data ?? {}

      if (userId) {
        localStorage.setItem("userId", userId)
        notify("Login successful", "success")
        await handleGetToken()
        navigate("/quick-launch-ads")
      } else {
        // notify("Login failed")
        console.log("New user from useFbAuth")
        window.location.href = "https://meet.getsoma.ai/booking"
      }
      
      return { success: true, data: response.data }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to verify Facebook token"
      dispatch(verifyFbTokenFailure(errorMessage))
      console.error(error)
      return { success: false, error: errorMessage }
    }
  }

  return { handleVerifyFbToken }
}

export default useFbAuth
